import React, { useContext } from "react";
import { FooterContext } from "../../../../../store/context/footer-context";
import UpdatedContactLink from "./ContactLink";
import EU from "../EU";
import Social from "./Social";
import "./index.scss";

const US = () => {
  const { t } = useContext(FooterContext);
  const allRightsReserved = `${t("All Rights Reserved")}${process.env.YEAR}`;

  return (
    <div className="GCL-F-B-US">
      <UpdatedContactLink />
      <EU mobile />
      <Social />
      <p className="GCL-F-B-US__text">{allRightsReserved}</p>
    </div>
  );
};
export default US;
